import React from 'react';
import UserInfo from 'screen/shared/UserInfo';

import {authAtom} from 'store';
import {useRecoilValue} from 'recoil';

export default function Profile() {
  const auth = useRecoilValue(authAtom);

  return <UserInfo mobile={auth?.mobile} user={auth?.user} />;
}
